import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, Grid, Row, useTheme, AppText } from '@streem/ui-react';
import { CallDetailKeyValueTile } from './call_detail_key_value_tile';
export const CallDetailItems = ({ trade, items, maxItemsPerRow, widthPercentage = 100, style, dataIdPrefix, columnsPerRow = 1, keyValueStyles, keyValueTitleStyles = {}, keyValueTileStyles = {}, callDetailItemStyles = {}, }) => {
    const theme = useTheme();
    const effectiveTitleFontSize = (callDetailItemStyles.titleFontSize ||
        theme.text.size.mediumLarge);
    const itemsPerRow = Math.min(maxItemsPerRow, items.length);
    const itemsSection = items.length > 0 ? (_jsx(ItemsSection, { items: items, itemsPerRow: itemsPerRow, theme: theme, dataIdPrefix: dataIdPrefix, columnsPerRow: columnsPerRow, keyValueStyles: keyValueStyles, keyValueTitleStyles: keyValueTitleStyles, keyValueTileStyles: keyValueTileStyles })) : (_jsx(NoItemsSection, { children: _jsxs(AppText, { size: "notQuiteAllTheWayMediumLarge", headingFontFamily: true, "data-testid": `${dataIdPrefix}-no-details-available`, children: ["No ", trade, " Details Available"] }) }));
    return (_jsxs(CallDetailsWrapper, { widthPercentage: widthPercentage, style: style, children: [_jsxs(HeaderWrapper, { titleFontSize: effectiveTitleFontSize, "data-testid": `${dataIdPrefix}-call-details-header`, children: [trade, " Call Details"] }), itemsSection] }));
};
const ItemsSection = ({ items, itemsPerRow, theme, dataIdPrefix, columnsPerRow = 1, keyValueStyles, keyValueTitleStyles, keyValueTileStyles, }) => {
    const effectiveItemFontSize = (keyValueStyles.fontSize || theme.text.size.medium);
    const callDetailItemTiles = items.map((item, idx) => {
        const attributes = convertItemToAttributes(item);
        return (_jsx(CallDetailKeyValueTile, { title: item.description, keyValuePairs: attributes, dataIdPrefix: `${dataIdPrefix}-${idx}`, columnsPerRow: columnsPerRow, keyValueStyles: { fontSize: effectiveItemFontSize }, keyValueTitleStyles: keyValueTitleStyles, keyValueTileStyles: keyValueTileStyles }, item.sid || idx));
    });
    return (_jsx(ItemsSectionWrapper, { columnsPerRow: itemsPerRow, "data-testid": "item-section", children: callDetailItemTiles }));
};
export const convertItemToAttributes = (item) => {
    const attributes = [];
    // Notes:
    //    1. It is expected that either manufacturer or brand will be present, but not both,
    //           based on the current design of the AHS and FTDR apps.  However, this component
    //           would not break--it would display both with Manufacturer first.
    //    2. The order matters for the attributes, as it is used to determine the order of display.
    if (item.manufacturer) {
        attributes.push({ key: 'Manufacturer', value: item.manufacturer });
    }
    if (item.brand) {
        attributes.push({ key: 'Brand', value: item.brand });
    }
    if (item.modelNumber) {
        attributes.push({ key: 'Model Number', value: item.modelNumber });
    }
    if (Array.isArray(item.symptoms) && item.symptoms.length > 0) {
        // single "Symptom" key is used for multiple symptoms
        attributes.push({ key: 'Symptom', value: item.symptoms });
    }
    if (item.tradeDescription) {
        attributes.push({ key: 'Trade Description', value: item.tradeDescription });
    }
    return attributes;
};
const CallDetailsWrapper = styled.div(props => ({
    display: 'inline-flex',
    flexDirection: 'column',
    borderRadius: '1px',
    width: `${props.widthPercentage}%`,
    ...props.style,
}));
const HeaderWrapper = styled.div(props => ({
    marginBottom: '.75rem',
    fontFamily: props.theme.text.headingFontFamily,
    fontWeight: 500,
    lineHeight: props.theme.text.lineHeight.medium,
    fontSize: props.titleFontSize,
}));
const ItemsSectionWrapper = styled(Grid)(props => {
    return {
        gridTemplateColumns: `repeat(${props.columnsPerRow}, 1fr)`,
        columnGap: '2rem',
        rowGap: '0.5rem',
        flexGrow: 1,
    };
});
const NoItemsSection = styled(Row)(({ theme }) => ({
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
    backgroundColor: theme.colors.grey01A50,
    padding: '2rem 0',
}));
//# sourceMappingURL=call_detail_items.js.map